import { render, staticRenderFns } from "./as-cost.vue?vue&type=template&id=881aff40&scoped=true&"
import script from "./as-cost.vue?vue&type=script&lang=js&"
export * from "./as-cost.vue?vue&type=script&lang=js&"
import style0 from "./as-cost.vue?vue&type=style&index=0&id=881aff40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881aff40",
  null
  
)

export default component.exports